import { render, staticRenderFns } from "./ClippingTypeIcon.vue?vue&type=template&id=16e47ae8"
import script from "./ClippingTypeIcon.vue?vue&type=script&lang=js"
export * from "./ClippingTypeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports